var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticStyle: {
      "width": "60%",
      "display": "inline-block"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "padding": "10px 10px",
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "padding": "10px 10px",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 120px",
      "color": "#888",
      "font-size": "16px",
      "text-align": "left"
    }
  }, [_vm._v("请选择表情包")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "text-align": "left"
    }
  }, [_c('emoji-icon', {
    attrs: {
      "iconConfig": _vm.iconConfig
    },
    on: {
      "select": _vm.selectIcon
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px"
    }
  }, _vm._l((_vm.data), function(d) {
    return _c('div', {
      staticStyle: {
        "padding": "10px 10px",
        "border": "1px solid #ddd",
        "margin-bottom": "10px"
      },
      domProps: {
        "innerHTML": _vm._s(d)
      }
    })
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b6c422","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = prZK
// module chunks = 1